// app/javascript/controllers/toast_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.classList.add("visible")
    })

    setTimeout(() => {
      this.dismiss()
    }, 3000)
  }

  dismiss() {
    this.element.classList.remove("visible")
    setTimeout(() => {
      this.element.remove()
    }, 500)
  }
}
